import { Component, Input } from '@angular/core';
import { Template } from 'src/app/care/scenarios/social-networks/whatsapp/select-whatsapp-template/shared/template.model';
import { WhatsappTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button-type.enum';

@Component({
  selector: 'app-whatsapp-template-item',
  templateUrl: './whatsapp-template-item.component.html',
  styleUrls: ['./whatsapp-template-item.component.scss'],
})
export class WhatsappTemplateItemComponent {
  @Input() template: Template;

  WhatsappTemplateButtonTypeEnum = WhatsappTemplateButtonTypeEnum;
}
